export default "__VITE_ASSET__12bbc7a2__"